// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"8224ca62bee7d8f6","487":"dc04b2b4c9ae1239","868":"d413c9a339462a6d","921":"d876b2b69fca4a92"}[chunkId] + ".js";
};